<template>
    <div style="margin-top: 70px; height: 70px;">
        <b-container>
            <b-row>
                <b-col class="promotion-wrapper" sm="11" md="6" offset-md="3">
                    <section class="promotion-header">
                        <h1>
                            체커 출시 기념
                            <br />무료체험 제품
                            <br />20% 할인 프로모션
                        </h1>
                        <h2>8/26 - 9/9 13:30까지</h2>
                    </section>
                    <section class="promotion-body">
                        <input placeholder="휴대폰 번호 입력" v-model="phoneNumber" type="text" />
                        <button v-bind:class="{removed: isSearched}" @click="searchCustomer">찾기</button>
                    </section>
                    <section class="promotion-footer">
                        <div v-bind:class="{hidden: isSearched}" class="search-icon-container">
                            <img
                                style="margin-top: 70px; width: 58px;"
                                src="@/assets/promotion/promotion-search-icon.png"
                                alt
                            />
                            <p>
                                전화번호 입력하고
                                <br />무료체험 중인 제품을 찾아보세요
                            </p>
                        </div>
                        <div style="padding-top: 10px;">
                            <h3
                                style="font-size: 12px; font-weight: 500; margin-top: 5px;"
                                v-bind:class="{hidden: !isSearched}"
                            >{{customerName}}님이 구매가능한 할인 패키지</h3>
                            <div class="product-list-container">
                                <div
                                    @click="updatePurchaseList(product.id, index)"
                                    class="product removed"
                                    v-for="(product, index) in availableProducts"
                                    v-bind:key="product.id"
                                    v-bind:class="{added: activeList.indexOf(index) > 0}"
                                >
                                    <img class="product-picture" :src="product.iconUrl" />
                                    <p class="name">{{product.name}}</p>
                                    <strike>{{product.price}}</strike>
                                    <div
                                        style="margin-top: 10px; display: flex; justify-content: space-between; align-items:center;"
                                    >
                                        <img
                                            style="width: 29px;"
                                            src="@/assets/promotion/sale-icon.png"
                                        />
                                        <span class="sale-price">{{product.salePrice}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button v-bind:class="{disabled: !isSearched}" @click="paymentBtnClick">선택</button>
                    </section>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import countTo from 'vue-count-to'
import {isCellPhone} from '../../modules/modules'
const alertOptions = {title: '', size: 'sm', okLabel: '확인'}

export default {
  name: 'campaign',
  components: { countTo },
  data () {
    return {
      customerName: '',
      isSearched: false,
      priceSwitcher: 62000,
      priceLinker: 59000,
      priceChecker: 48000,
      purchaseList: [],
      activeList: [9],
      paymentAmount: 0,
      benefitAmount: 0,
      phoneNumber: '',
      availableProductIdList: [],
      availableProducts: [],
      products: [
        {
          id: 1,
          name: 'Switcher 1구',
          iconUrl: require('@/assets/promotion/promotion-switcher.png'),
          price: '57,000원',
          salePrice: '45,600원',
          payment: 45600,
          benefit: 11400
        },
        {
          id: 2,
          name: 'Switcher 2구',
          iconUrl: require('@/assets/promotion/promotion-switcher.png'),
          price: '62,000원',
          salePrice: '49,600원',
          payment: 49600,
          benefit: 12400
        },
        {
          id: 3,
          name: 'Linker',
          iconUrl: require('@/assets/promotion/promotion-linker.png'),
          price: '59,000원',
          salePrice: '47,200원',
          payment: 47200,
          benefit: 11800
        },
        {
          id: 4,
          name: 'Checker',
          iconUrl: require('@/assets/promotion/promotion-checker.png'),
          price: '48,000원',
          salePrice: '38,400원',
          payment: 38400,
          benefit: 9600
        }
      ]
    }
  },
  methods: {
    putComma: function (string) {
      return string.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    async searchCustomer () {
      if (!isCellPhone(this.phoneNumber)) {
        this.$dialogs.alert('휴대폰 번호를 확인해주세요.', alertOptions)
        return
      }
      this.availableProducts = []
      this.availableProductIdList = []
      let vm = this
      await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/free-trials/?phone_number=' + this.phoneNumber)
        .then((response) => {
          if (response.status === 200) {
            this.$store.commit('updatePromotionCustomerId', response.data.customer_info.id)
            this.customerName = response.data.customer_info.name
            if (response.data.free_trial_list.length > 0) {
              response.data.free_trial_list.forEach(function (freeTrial) {
                vm.availableProductIdList.push(freeTrial.product_id)
              })
            this.isSearched = true
            } else {
              this.$dialogs.alert('먼저 제품을 무료체험 신청해주세요 !', alertOptions)
              this.$router.push({name: 'Checker'})
            }
          }
          for (var i = 0; i < this.availableProductIdList.length; i++) {
            for (var k = 0; k < this.products.length; k++) {
              if (this.availableProductIdList[i] === this.products[k].id) {
                this.availableProducts.push(this.products[k])
                }
              }
            }
        })
        .catch((error) => {
          console.log(error)
          this.$dialogs.alert('먼저 제품을 무료체험 신청해주세요 !', alertOptions)
          this.$router.push({name: 'Checker'})
        })
    },
    updatePurchaseList: function (productId, index) {
      if (this.activeList.indexOf(index) === -1) {
        this.activeList.push(index)
        this.purchaseList.push(productId)

        this.paymentAmount += this.findProduct(productId).payment
        this.benefitAmount += this.findProduct(productId).benefit
      } else {
        let targetIndex = this.activeList.findIndex(x => x === index)
        let targetIndexPurchase = this.purchaseList.findIndex(x => x === productId)

        this.activeList.splice(targetIndex, 1)
        this.purchaseList.splice(targetIndexPurchase, 1)

        this.paymentAmount -= this.findProduct(productId).payment
        this.benefitAmount -= this.findProduct(productId).benefit
      }
    },
    findProduct: function (productId) {
      var result
      this.products.forEach(function (product) {
        if (product.id === productId) {
          result = product
        }
      })
      return result
    },
    paymentBtnClick: function () {
      this.$dialogs.alert('종료된 프로모션 입니다.', alertOptions)
      // if (this.purchaseList.length === 0) {
      //   this.$dialogs.alert('구매할 패키지를 골라주세요.', alertOptions)
      //   return
      // }
      // this.$store.commit('updatePromotionPaymentAmount', this.paymentAmount)
      // this.$store.commit('updatePromotionBenefitAmount', this.benefitAmount)
      // this.$router.push({ name: 'PromotionPayment' })
    }
  }
}
</script>
<style scoped>

.promotion-wrapper {
  padding: 0;
  background-color: #fafafa;
}

.promotion-header {
  margin-top: 50px;
  font-weight: bold;
}
.promotion-header h1{
  font-size: 20px;
  letter-spacing: -0.5px;
}
.promotion-header h2{
  font-size: 15px;
  color: #ff6666;
}
.promotion-body {
  margin-top: 47px;
  display: flex;
  justify-content: center;
}
.promotion-body input {
  padding: 10px;
  font-size: 14px;
  width: 70%;
  height: 32px;
  border-radius: 3px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.11);
  border: solid 1px #eef0f1;
  outline: 0;
  -webkit-appearance:none;
}
.promotion-body button {
  width: 59px;
  height: 32px;
  border-radius: 3px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.11);
  border: solid 1px #eef0f1;
  background-color: #fff;
  color: #6f97fa;
  font-weight: bold;
  margin-left: 7px;
  font-size: 12px;
  -webkit-appearance:none;
}
.promotion-footer {
  margin-top: 30px;
  min-height: 340px;
  /* background-color: rgba(248, 248, 248, 0.66);
   */
   background-color: #fff;

}

.promotion-footer .product {
  width: 108px !important;
  height: 184px;
  padding: 11px;
  border-radius: 3px;
  box-shadow: 0 1px 4px 0 rgba(148, 151, 174, 0.5);
  background-color: #ffffff;
  position: relative;
}

.promotion-footer .product .icon {
  width: 12px;
  position: absolute;
  right: 6px;
}

.promotion-footer .product .product-picture {
  margin-top: 10px;
}

.promotion-footer .product .name {
  font-size: 11px;
  font-weight: 500;
  letter-spacing: -0.37px;
  margin: 0;
  margin-top: 10px;
}
.promotion-footer .product strike {
  font-size: 11px;
  color: #979797;
  letter-spacing: -0.37px;
}

.promotion-footer .product .sale-price {
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.47px;
}

.promotion-footer .product-list-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 10px;
}

.promotion-footer button {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  width: 95%;
  height: 57px;
  border-radius: 3px;
  background-color: #6f97fa;
  color: #fff;
  font-size: 19px;
  font-weight: bold;
  border: 0;
  outline: 0;
}

.search-icon-container p {
  margin-top: 17px;
  font-size: 12px;
  font-weight: 500;
  color: #aeb5bd;
  letter-spacing: -0.4px;
}
.added {
  opacity: 1 !important;
  border: 1px solid #4ca1ff !important;
}
.removed {
  opacity: 0.5;
}
.disabled {
  background-color: #cfd2d5 !important;
}
.hidden {
  display: none !important;
}
.show {
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/promotion/promotion.vue